module.exports = __webpack_public_path__ + "202408221624/img/jingya.cf269a19.png";